import ICommand from './ICommand';
import Element from '../element';

export abstract class BaseCommand implements ICommand {

    protected elements: Element[] = [];
    protected commands: ICommand[] = [];

    constructor(
        protected scenePreview: any,
    ) { }

    public abstract execute(): void;

    public revert(): void {
        this.revertCommands();
        this.removeElements();
    }

    protected removeElements() {
        this.elements.forEach((x) => {
            x.remove();
            this.scenePreview.elements.splice(this.scenePreview.elements.indexOf(x), 1);
        });
        this.elements = [];
    }

    protected revertCommands() {
        this.commands.forEach((x) => x.revert());
        this.commands = [];
    }

    protected addCommand(command: ICommand) {
        this.commands.push(command);
        command.execute();
    }
}
